import { baseUrl } from '@/settings'
import { get } from '../rest'

const systemModeApi = {
  get: () => get(`${baseUrl}/manage`),
  getDates: () => get(`${baseUrl}/managedates`)
}
export default systemModeApi
